import { Collection } from 'lodash';
import { IManagingLinuxServiceInstance } from '../../api/models';
import { ApplicationInstanceEnvironmentComparison } from './ApplicationInstanceEnvironmentComparison';
import { RowDefinition } from './ComparisonTable';

interface LinuxServiceEnvironmentComparisonProps {
    data: IManagingLinuxServiceInstance[];
}

export const LinuxServiceEnvironmentComparison = ({ data }: LinuxServiceEnvironmentComparisonProps) => {
    const rows = [
        { rowName: 'Unit File State', property: 'unitFileState' },
        { rowName: 'Load State', property: 'loadState' },
        { rowName: 'Active State', property: 'activeState' },
        { rowName: 'Sub State', property: 'subState' },
        { rowName: 'User', property: 'user' },
        { rowName: 'Control Group', property: 'controlGroup' },
        { rowName: 'Exec Start', property: 'execStart' },
        { rowName: 'Working Directory', property: 'workingDirectory' },
        { rowName: 'Fragment Path', property: 'fragmentPath' },
        { rowName: 'Main PID', property: 'mainPid', customStatusFunction: (value: string) => 'success' },
        { rowName: '-', property: '', customDisplayValueFunction: (values: Collection<{ value: string; count: number }>) => '' },
    ] as RowDefinition<IManagingLinuxServiceInstance>[];

    return <ApplicationInstanceEnvironmentComparison data={data} rows={rows} />;
};
